module.exports = __webpack_public_path__ + "img/logo.2958efc8.png";